import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";

const FaqSection = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-5">
          <p className="text-sm font-medium text-primary-600 mb-2">常见问题</p>
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
            关于档案局，你可能想问
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            如果下面的问题没有解答你的疑惑，欢迎直接到爆料页留言，编辑会挑选高频问题补充进来。
          </p>
          <Link
            to="/about#submit"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-chat-3-line" />
            前往提问与投稿
          </Link>
        </div>

        <div className="lg:col-span-7">
          <div className="divide-y divide-background-200/80 border-y border-background-200/80">
            {faqs.map((item, index) => {
              const isOpen = open === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="w-full flex items-start justify-between gap-4 py-5 text-left"
                  >
                    <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
                      {item.q}
                    </h3>
                    <span
                      className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-lg transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                    </span>
                  </button>
                  {isOpen && (
                    <p className="pb-5 pr-10 text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;